<p>client-logo-widget works!</p>
